module.exports = __webpack_public_path__ + "img/ODWH1_6.d747dbe3.png";